module.exports = __webpack_public_path__ + "static/media/Breakfast-paid.87b1118c.png";